(ns fablo-offers.app.components.offer
  (:require ["@chakra-ui/react" :as ch]
            ["framer-motion" :as fm]
            ["react-icons/fa" :refer [FaCalendarAlt FaCamera FaCheckCircle
                                      FaClock FaCut FaHourglassHalf FaUserFriends] :as icons]
            ["react-images" :as react-images]
            ["@iconify/react" :as iconify]
            [cljs-bean.core :refer [->js]]
            [clojure.string :as string]
            [fablo-offers.app.components.app :as app]
            [fablo-offers.app.screens.payment :as payment]
            [fablo-offers.common.lib.hooks :as hooks]
            [fablo-offers.common.lib.i18n :as i18n]
            [fablo-offers.common.lib.routing :as routing]
            [fablo-offers.common.state :as s]
            [fablo-offers.common.tracking :refer [track use-track get-tracking-params]]
            [fablo-offers.common.utils :as u]
            [reitit.frontend.easy :as rfe]
            [rumext.alpha :as mf]
            [tick.core :as tick]
            [tick.locale-en-us]))

(i18n/add-translations
 :en
 :offer
 {:choose "Choose"})

(i18n/add-translations
 :pl
 :offer
 {:choose "Wybierz"})

(defn join-path [path x]
  (if path
    (str path ">" x)
    x))

(defn drop-path [path]
  (some-> path (string/replace #"/[^/]+$" "")))

(defn offer-path [provider-id path offer-id query-params]
  (routing/href (cond
                  (and path (= :form path)) :screen/offer-form
                  path :screen/offer-path
                  :else :screen/offer)
                {:provider-id provider-id
                 :offer-id offer-id
                 :path path}
                query-params))

(def icons-dict
  {:calendar FaCalendarAlt
   :clock FaClock
   :hourglass FaHourglassHalf
   :user icons/FaUser
   :users FaUserFriends
   :scissors FaCut
   :camera FaCamera
   :heart icons/FaHeart})

(mf/defc image-with-popup [props]
  (let [opened? (mf/use-state false)
        ref (mf/use-ref)]
    (ch/useOutsideClick
     #js {:ref ref
          :enabled @opened?
          :handler #(reset! opened? false)})
    [:> ch/Image
     (u/js-camel-case-keys
      (merge
       props
       {:as fm/motion.img
        :layout true
        :on-click #(swap! opened? not)
        :cursor :pointer}
       (when @opened?
         {:position :absolute
          :max-width 300
          :height 350
          :box-shadow :dark-lg
          :background :white
          :top -150
          :left 0})))]))

(mf/defc gallery [{:keys [images]}]
  (let [popup (mf/use-state nil)]
    [:> ch/Box
     {:overflow-x :scroll
      :width "100%"
      :max-height "100px"}
     [:> ch/Box
      {:display :flex}
      (for [[i img] (map-indexed vector images)]
        [:> ch/Image
         {:key i
          :mr 2
          :rounded :sm
          :display :inline-block
          :src img
          :h "100px"
          :fit :contain
          :on-click #(reset! popup i)}])]
     [:> react-images/ModalGateway
      {}
      (when @popup
        [:> react-images/Modal
         {:onClose #(reset! popup nil)}
         [:> react-images/default
          {:currentIndex @popup
           :views (clj->js (map #(do #js {:src %}) images))}]])]]))

(mf/defc icons-desc-cmp [{:keys [sections]}]
  (let [t (hooks/use-t "offer")]
    [:> ch/VStack {:align :stretch
                   :spacing 4
                   :mb 6
                   :mx 2}
     (for [s sections
           :when (or (:text s) (seq (:slots s)) (:photos s))
           :let [text (if (map? (:text s)) (t (:text s)) (:text s))
                 long-text? (or (and text
                                     (> (count (string/split-lines text)) 2))
                                (:photos s))
                 icon (or (icons-dict (:icon s))
                          (aget icons (:icon s))
                          (:icon s))]]
       [:> ch/HStack
        {:spacing 3
         :align :center
         :bg (when (and icon (not long-text?)) "surface-secondary.200")
         :border (when (and icon long-text?) "1px solid var(--chakra-colors-border-secondary-500)")
         :rounded :md
         :p 2
         :key (hash s)}
        (when icon
          (if (string? icon)
            [:& iconify/Icon
             {:icon icon
              :color "var(--chakra-colors-border-secondary-500)"
              :width 29
              :height 29}]
            [:> ch/Icon {:as icon
                         :font-size :lg
                         :color :border-secondary.500}]))
        (when text
          [:> ch/Text
           {:white-space :pre-wrap
            :flex 1
            :font-weight (when icon 500)
            :text-align (if long-text? "left" "center")}
           [:span {:dangerouslySetInnerHTML {:__html text}}]])
        (when-let [href (:href s)]
          [:> ch/Link
           {:white-space :pre-wrap
            :isExternal true
            :href (t href)
            :text-decoration :underline}
           (t (or (:link s) href))])

        (when-let [slots (seq (:slots s))]
          [:> ch/Box {}
           (for [slot slots]
             [:> ch/Tag
              {:mr 2
               :variant :outline
               :key (hash slot)
               :color-scheme :border-secondary}
              (t slot)])])
        (when-let [photos (:photos s)]
          [:& gallery {:images photos}]
          #_[:> ch/Box {:position :relative}
             (for [photo photos]
               [:& image-with-popup
                {:mr 2 :mb 2
                 :display :inline-block
                 :src photo
             ;:w "80px"
                 :h "50px"
                 :fit :contain
                 :align :center}])])])]))

(mf/defc riverview-contact-button [{:keys []}]
  (let [open (mf/use-state false)
        t (hooks/use-t "offer")]
    [:*
     [:> ch/Drawer
      {:is-open @open
       :placement :bottom
       :on-close #(reset! open false)}
      [:> ch/DrawerOverlay {}]
      [:> ch/DrawerContent {:text-align :center}
       [:> ch/DrawerHeader {}
        [:> ch/Heading {:size :md}
         (t {:en "To buy this offer contact River View Wellness Centre"
             :pl "Skontaktuj się z River View Wellness Centre, aby skorzystać z oferty."})]]
       [:> ch/DrawerBody {}

        [:> ch/Text {}
         (t {:en "Ordering online will be available very soon!"
             :pl "Zamawianie online będzie możliwe już niedługo!"})]

        [:> ch/Button
         {:size :lg
          :color-scheme :brand
          :my 8
          :as "a"
          :href "tel:+48223288640"}
         [:> ch/Icon {:as icons/FaPhoneAlt :mr 2}]
         (t {:en "CONTACT US"
             :pl "ZADZWOŃ"})]]]]
     [:> ch/Button
      {:size :lg
       :color-scheme :brand
       :my 4
       :as "a"
       :min-w "200px"
       :h "64px"
       :on-click #(reset! open true)}
      (t {:en "CHOOSE"
          :pl "WYBIERZ"})]]))

(mf/defc offer-card
  {::mf/register app/components
   ::mf/register-as :offer/card}
  [{:keys [offer form icons-desc provider] :as _params}]
  (use-track "Offer card view")
  (use-track
   (mf/deps (hash offer))
   :view-content-price
   (get-tracking-params
    {:type :view-content-price
     :provider-id (:provider/id provider)
     :offer offer})
   (boolean (some #{:view-content-price} (:offer/tracking offer))))
  (let [t (hooks/use-t "offer")
        route-state @(s/use-atom app/route-state)
        query-params (cond-> {}
                       (:prev-order route-state) (assoc :prev-order (:prev-order route-state)))
        href (offer-path (:provider-id offer)
                         :form
                         (:offer/id offer)
                         query-params)
        promo-price (:offer/promo-price offer)
        promo-price (when (or (not (:to promo-price))
                              (tick/> (:to promo-price) (tick/date-time)))
                      promo-price)
        price (or (:price promo-price) (t (:offer/price offer)))]
    [:> ch/Box
     {:text-align :left}
     [:& app/parallax-image-card
      {:image (:offer/image offer)
       :top-space 200}

      [:> ch/Heading
       {:size :lg :font-weight :bold :text-align :center}
       (t (:offer/name offer))]
      (when price
        [:> ch/Heading
         {:size :md
          :color :black
          :my 2
          :text-align :center}
         (if (number? price)
           (str (.toFixed price) " PLN")
           price)])]

     [:> ch/Box
      {:px 4
       :py 8}

      [:> ch/Box {}
       (when
        icons-desc [:& icons-desc-cmp {:sections icons-desc}])

       (when (:offer/long-desc offer)
         [:> ch/Text {:white-space :pre-wrap :align :center :mb 8}
          (t (:offer/long-desc offer))])

       (when promo-price
         [:> ch/Box {:mt "70px"
                     :pt "60px"
                     :h "90px"
                     :position :relative}
          (when (or (:text promo-price)
                    (:to promo-price))
            [:> ch/Box
             {:text-transform :uppercase
              :px 1
              :py 2
              :bg :yellow.500
              :color :white
              :font-weight :bold
              :rounded :md
              :font-size :sm
              :width 150
              :transform "rotate(15deg)"
              :position :absolute
              :top 0
              :left "48%"
              :text-align :center}
             (:text promo-price) [:br]
             (when (:to promo-price)
               [:*
                "DO " (tick/format "dd.MM" (:to promo-price))])])
          [:> ch/Box
           {:background :red.500
            :h "3px"
            :rounded :md
            :width "100px"
            :ml "-50px"
            :left "50%"
            :bottom "-14px"
            :transform "rotate(7deg)"
            :position :absolute}]
          [:> ch/Heading
           {:size :md
            :mb 2
            :text-align :center
            :white-space :pre-wrap}
           (str (.toFixed (:price promo-price)) " PLN")]])

       (when-let [p (:offer/price offer)] ;; monthly-price
         (let [note (:footnote promo-price)]
           [:> ch/Box {}
            [:> ch/Heading
             {:size :md
              :mb 2
              :color :black
              :text-align :center
              :white-space :pre-wrap}
             (if (number? p)
               (str (.toFixed p) " PLN")
               (t p))
             (when note " *")]
            (when note
              [:> ch/Text
               {:text-align :center
                :font-size :sm
                :color :gray.500}
               note])]))]

      [:> ch/Box
       {:position :sticky
        :bottom 0
        :text-align :center
        :bg "linear-gradient(rgba(255,255,255,0), rgba(255,255,255,1) 30%)"}
       (if (:riverview/contact-button offer)
         [:& riverview-contact-button {}]
         [:> ch/Button
          {:size :lg
           :color-scheme :brand
           :my 4
           :as "a"
           :min-w "200px"
           :h "64px"
           :font-family "Abhaya Libre"
           :font-weight 800
           :font-size "20px"
           :href href}
          (t "choose")])]]]))

(mf/defc inline-offer
  {::mf/register app/components
   ::mf/register-as :catalog/inline-offer}
  [{:keys [offer] :as params}]
  (let [query (s/use-query [:screen/offer-form {:offer-id (:offer/id offer)
                                                :provider-id (:provider-id offer)}])]
    (when (:app/component (:data query))
      (app/render-cmp (:data query)))))

(mf/defc expandable-box [{:keys [opened? children box-id on-close]}]
  (let [ref (mf/use-ref)
        popup-ref (mf/use-ref)
        height (mf/use-state 0)
        _ (mf/use-layout-effect
           (mf/deps [@height])
           (fn []
             (let [h (some-> ref .-current .-clientHeight)]
               (when (and h (pos? h) (not= h @height))
                 (reset! height h)))))
        #_(ch/useOutsideClick #js {:ref popup-ref
                                   :handler on-close})]
    (if-not opened?
      [:div {:ref ref}
       children]
      [:*
       [:> ch/Box
        {:height (str @height "px")}]
       [:> ch/Box
        {:as fm/motion.div
         :position :fixed
         :top 0 :left 0 :right 0 :bottom 0
         :initial {:background "rgba(0,0,0,0.0)"}
         :animate {:background "rgba(0,0,0,0.5)"}
         :overflow :scroll
         :z-index 3}
        [:> ch/Box
         {:as fm/motion.div
          :layout-id box-id ;; fixme
          :rounded :lg
          :bg :white
          :margin "0 auto"
          :border "1px solid var(--chakra-colors-brand-500)"
          :box-shadow :base
          :max-w 500
          :position :relative
          :overflow :hidden}
         [:> ch/CloseButton
          {:rounded :full
           :bg :gray.200
           :position :absolute
           :top 4
           :right 4
           :on-click on-close}]
         [:div {:ref popup-ref}
          children]]]])))

(mf/defc offer-box [{:keys [offer provider]}]
  (let [t (hooks/use-t "offer")
        route-state @(s/use-atom app/route-state)
        href (or (:href offer)
                 (offer-path (:provider-id route-state)
                             (join-path (:path route-state) (:offer-id route-state))
                             (:offer/id offer)
                             (when (:prev-order route-state)
                               {:prev-order (:prev-order route-state)})))
        active? (:offer/is-active offer)]
    [:> ch/Box {:my 4}
     [:> ch/Box
      {:bg :white
       :box-shadow :base
       :rounded :lg
       :border "1px solid var(--chakra-colors-border-primary-500)"
       :overflow :hidden
       :text-align :left}

      (when-let [src (:offer/image offer)]
        [:> ch/Image
         {:src src
          :m 2
          :border-radius :md
          :border "1px solid var(--chakra-colors-border-primary-500)"
          :height 250
          :fit :cover
          :object-position "50% 30%"
          :align :center
          :width "calc(100% - 16px)"}])

      [:> ch/Box
       {:px 3
        :pt 2
        :pb 4}
       [:> ch/Heading
        {:size :md
         :font-size "24px"
         :text-align :center}
        [:> ch/Box {}
         (t (:offer/name offer))]]
       [:> ch/Text
        {:my 2
         :text-align :left
         :white-space :pre-wrap}
        (t (:offer/short-desc offer))]
       [:> ch/Box {:text-align :center}
        #_(when-let [p (:offer/price offer)]
            [:> ch/Text
             {:font-weight :bold
              :color :brand.500}
             (.toFixed p) " PLN"])
        (when-not (:riverview/contact-button offer)
          [:> fm/motion.div
           {:whileTap #js {:scale 0.9}}
           [:> ch/Button
            {:color-scheme :brand
             :as "a"
             :href (when active? href)
             :size :lg
             :min-w "200px"
             :h "64px"
             :mt 4
             :font-family "Abhaya Libre"
             :font-weight 800
             :font-size "20px"
             :disabled (not active?)
             :on-click (fn []
                         (js/console.log "BOTTOM")
                         (vreset! app/next-transition :bottom))}
            (if active?
              (t "choose")
              "oferta zakończona")]])]]]]))

(mf/defc offers-list
  {::mf/register app/components}
  [{:keys [offers provider description] :as params}]
  (let [t (hooks/use-t "offer")]
    [:div {}
     [:& app/provider-header {:provider provider}]
     (when description
       [:> ch/Text {:p 4}
        (t description)])
     [:> ch/Box
      {:pb 2}
      (for [x offers]
        [:& offer-box {:offer x
                       :provider provider}])]]))

(mf/defc group-button [{:keys [name icon on-click]}]
  [:> ch/Box
   {:box-shadow :base
    :rounded :lg
    :border "1px solid var(--chakra-colors-brand-500)"
    :text-align :center
    :px 2
    :py 2
    :on-click on-click
    :cursor :pointer}
   [:> ch/Icon {:as (aget icons icon)
                :mt 1
                :font-size "32px"
                :color :brand.500}]
   [:> ch/Text {:font-weight :semibold} name]])

;; xx
(mf/defc offers-list2
  {::mf/register app/components
   ::mf/register-as :general/offers-list-2}
  [{:keys [offers provider description groups] :as params}]
  (let [t (hooks/use-t "offer")
        opened-group (mf/use-state nil)]
    [:div {}
     [:& app/provider-header {:provider provider}]
     (when description
       [:> ch/Text {:p 4}
        (t description)])
     [:> ch/Box
      {:pb 2}
      (when groups
        [:> ch/Box {:px 4}
         [:> ch/Heading {:size :sm :m 4 :text-align :center} "Browse our offer"]
         [:> ch/SimpleGrid
          {:columns 2
           :spacing 4
           :m "32px auto"
           :max-w 400}
          (for [g groups]
            [:& group-button (assoc g
                                    :on-click #(reset! opened-group g))])]

         [:> ch/Modal
          {:is-open (some? @opened-group)
           :on-close #(reset! opened-group nil)
           :size :lg}
          [:> ch/ModalOverlay {}]
          (let [g @opened-group]
            [:> ch/ModalContent {}
             [:> ch/ModalHeader {} (:name g)]
             [:> ch/ModalCloseButton {}]
             [:> ch/ModalBody {}
              (when-let [d (:desc g)]
                [:> ch/Text {} d])
              (for [x offers
                    :when (contains? (:groups x) (:id g))]
                [:& offer-box {:offer x
                               :provider provider}])]])]])
      (when-not groups
        (for [x offers]
          [:& offer-box {:offer x
                         :provider provider}]))]]))

(mf/defc header
  {::mf/register app/components
   ::mf/register-as :header}
  [{:keys [text mt mb]}]
  (let [t (hooks/use-t "offer")]
    [:> ch/Heading
     {:size :md
      :font-size "24px"
      :font-weight "800"
      :align :center
      :mt (or mt 2)
      :mb (or mb 2)
      :white-space :pre-wrap}
     (t text)]))

(mf/defc text
  {::mf/register app/components
   ::mf/register-as :text}
  [{:keys [text align color html p white-space]}]
  (let [t (hooks/use-t "offer")]
    [:> ch/Text
     {:mb 2
      :align (or align "left")
      :color color
      :white-space (or white-space "pre-wrap")
      :p p}
     (if text
       (t text)
       [:span {:p p :dangerouslySetInnerHTML {:__html (t html)}}])]))

(mf/defc image
  {::mf/register app/components
   ::mf/register-as :image}
  [{:keys [src]}]
  [:> ch/Box {:margin "0 -16px"}
   [:> ch/Image
    {:src src
     :width "100%"}]])

(mf/defc spacer
  {::mf/register app/components
   ::mf/register-as :spacer}
  [{:keys []}]
  [:> ch/Spacer {:min-h 8}])

(mf/defc info-popup
  {::mf/register app/components
   ::mf/register-as :info-popup}
  [{:keys [title color content]}]
  (let [opened? (mf/use-state false)
        t (hooks/use-t "riverview")]
    [:*
     [:> ch/Link
      {:display :block
       :my 4
       :color color
       :text-decoration :underline
       :text-align :center
       :on-click #(reset! opened? true)}
      [:> ch/Icon {:as icons/FaInfoCircle :mr 2 :font-size "1.2em" :vertical-align :middle}]
      (t title)]

     [:> ch/Modal
      {:is-open @opened?
       :on-close #(reset! opened? false)}
      [:> ch/ModalOverlay {}]
      [:> ch/ModalContent {}
       [:> ch/ModalHeader {}
        [:> ch/Heading {:size :lg :align :center}
         (t title)]]
       [:> ch/ModalCloseButton {}]
       [:> ch/ModalBody {}
        (if (sequential? content)
          (for [x content]
            [:* {:key (hash x)}
             (app/render-cmp x)])
          (t content))]
       [:> ch/ModalFooter {:justify-content :center :pb 8}
        [:> ch/Button {:on-click #(reset! opened? false) :size :lg :colorScheme "brand" :w "150px"}
         "Ok"]]]]]))

(mf/defc catalog
  {::mf/register app/components
   ::mf/register-as :offer/catalog}
  [{:keys [provider content offer tracking]}]
  (use-track
   (mf/deps (hash content))
   "Offers catalog view"
   {})
  (use-track
   (mf/deps (hash content))
   :view-content
   (get-tracking-params
    {:type :view-content
     :provider-id (:provider/id provider)
     :offer offer})
   (boolean (some #{:view-content} tracking)))
  [:> ch/Flex
   {:min-h "calc(100vh - 120px)"
    :direction :column}
   [:> ch/Box
    {:px 4}
    (for [x content]
      (when x
        [:* {:key (hash x)}
         (app/render-cmp x)]))]
   [:div]])

(mf/defc catalog-buttons
  {::mf/register app/components
   ::mf/register-as :catalog/buttons}
  [{:keys [items inversed-colors? text-color]}]
  (let [t (hooks/use-t "offer")
        route-state @(s/use-atom app/route-state)
        accent-color "var(--chakra-colors-surface-primary-500)"]
    [:> ch/SimpleGrid
     {:columns 2
      :spacing 4
      :m "32px auto"
      :max-w 400}
     (for [{:keys [icon icon-url icon-size href offer/id offer/name text size offer/tracking] :as item} items
           :let [text (t (or text name))
                 icon-cmp
                 (cond
                   icon
                   (mf/html
                    (if (string/includes? icon ":")
                      [:& iconify/Icon
                       {:icon icon
                        :color (or text-color (if inversed-colors? "#fff" accent-color))
                        :width 56
                        :height 56}]
                      [:> ch/Icon {:as (aget icons icon)
                                   :my 2
                                   :font-size "56px"
                                   :color (or text-color (if inversed-colors? "#fff" accent-color))}]))
                   icon-url
                   (mf/html
                    [:> ch/Image
                     {:src icon-url
                      :my 2
                      :height (str (or icon-size 56) "px")
                      :fit :contain
                      :align :center}]))]]
       [:> fm/motion.div
        {:whileTap #js {:scale 0.9}
         :key (hash item)
         :style {:gridColumnEnd (when (= :lg size) "span 2")}}
        [:> ch/Box
         {:as "a"
          :box-shadow :base
          :href (or href
                    (offer-path (:provider-id route-state)
                                (join-path (:path route-state) (:offer-id route-state))
                                id
                                nil))
          :on-click (fn [_e]
                      (track "Catalog button clicked"
                             {"Button text" text
                              "Button to offer" id
                              "Href" href})
                      (when (some #{:contact} tracking)
                        (track :contact (get-tracking-params
                                         {:type :contact
                                          :provider-id (:provider-id route-state)}))))
          :rounded :lg
          :bg (if inversed-colors? accent-color "#fff")
         ;:border "1px solid var(--chakra-colors-gray-600)" #_"1px solid var(--chakra-colors-brand-500)"
          :border (when-not inversed-colors? "1px solid var(--chakra-colors-surface-primary-500)")
          :text-align :center
          :px 2
          :py 3
          :sx (when (not= :lg size) #js {:aspectRatio "1"})
          :display :flex
          :flex-direction :column
          :align-items :center
          :justify-content :center}
         icon-cmp
         [:> ch/Flex
          {:align :center
           :justify :center
           :min-h "54px"}
          [:> ch/Heading
           {:font-weight (if inversed-colors? "800" "semibold")
            :color (or text-color (if inversed-colors? "#fff" accent-color))
            :font-size :lg}
           text]]]])]))

(mf/defc catalog-tabs
  {::mf/register app/components
   ::mf/register-as :catalog/tabs}
  [{:keys [items initial-closed?]}]
  (let [t (hooks/use-t "offer")
        ref (mf/use-ref nil)
        default-tab (some-> js/window.location.hash (.substr 1) not-empty js/parseInt)]
    [:> ch/Tabs
     {;:is-lazy true
      :ref ref
      :defaultIndex (or default-tab
                        (if-not initial-closed? 0 -1))
      :align (when (< (count items) 4) "center")
      :my 4
      :variant "soft-rounded"
      :on-change (fn [idx]
                   (js/setTimeout
                    (fn []
                      (some-> ref .-current (.scrollIntoView #js {:behavior "smooth"})))
                    100)
                   (track "Catalog tab changed"
                          {"Tab index" idx
                           "Tab name" (t (:name (nth items idx)))}))}
     [:> ch/TabList
      {:position :sticky
       :top 74
       :bg "rgba(255,255,255,0.9)";:white
       :backdrop-filter "blur(4px)"
       :py 1
       :z-index 1
       :mx -4
       :overflow-x :scroll}
      (for [{:keys [name] :as item} items]
        [:> ch/Tab
         {:key (hash item)
          :border "1px solid var(--chakra-colors-border-primary-500)"
          :rounded :lg
          :mx 1
          :w "110px"
          :min-w "110px"
          :h "80px"
          :font-family "Abhaya Libre"
          :font-weight 800
          :bg :white
          :color "border-primary.500"
          :_selected {:bg "surface-primary.500"
                      :color :white}}
         (t name)])]

     [:> ch/TabPanels {}
      (for [{:keys [name content] :as item} items]
        [:> ch/TabPanel
         {:px 0
          :key (hash item)}
         (when-not (:without-header item)
           [:> ch/Heading
            {:size :md
             :font-size "24px"
             :mt 6
             :mb 2
             :align :center}
            (t name)])
         [:div {}
          (for [x content]
            [:* {:key (hash x)}
             (app/render-cmp x)])]])]]))

(mf/defc catalog-offer-cards
  {::mf/register app/components
   ::mf/register-as :catalog/offer-cards}
  [{:keys [items]}]
  (let [t (hooks/use-t "offer")]
    [:> ch/Box
     {:pb 2
      :mt 4}
     (for [x items]
       [:& offer-box
        {:offer x
         :key (hash x)}])]))

;; fixme
(defn date-time-format [d]
  (let [d (js/Date. d)]
    (str
     (string/replace (.toLocaleTimeString d) #":\d\d$" "")
     ", "
     (.toLocaleDateString d))))

(mf/defc payments-section [{:keys [payments provider order offer] :as params}]
  (let [t (hooks/use-t "offer")
        payments (sort-by :payment/due-date payments)
        future-payments (filter #(= (:payment/status %) :future) payments)
        requested-payments (filter #(#{:requested :waiting :error} (:payment/status %)) payments)
        done-payments (filter #(#{:done} (:payment/status %)) payments)
        order-state (:order/state order)]
    [:> ch/Box {}
     (when (seq requested-payments)
       [:> ch/Box {}
        [:> ch/Text {:font-weight :bold
                     :text-align :center
                     :mb 2}
         (t {:pl "Do zapłaty"
             :en "To pay"})]
        (for [payment requested-payments]
          [:& payment/payment-box
           (assoc params
                  :customer (:customer order-state)
                  :payment payment)])])
     (when (and (empty? requested-payments) (seq future-payments))
       [:> ch/Box {}
        [:> ch/Text {:font-weight :bold
                     :text-align :center
                     :mb 2}
         "Nadchodzące płatności"]
        [:> ch/Text {:font-size :sm
                     :mb 4
                     :text-align :center}
         "Możesz je opłacić później. Przypomnimy Ci o nich e-mailiem."]
        (for [payment (take 1 future-payments)]
          [:& payment/payment-box
           (assoc params
                  :customer (:customer order-state)
                  :payment payment
                  :disabled? (seq requested-payments))])])

     (when (seq done-payments)
       [:> ch/Box {}
        [:> ch/Text {:font-weight :bold
                     :text-align :center
                     :mb 2}
         "Historia płatności"]
        (for [payment done-payments]
          [:& payment/payment-box
           (assoc params
                  :customer (:customer order-state)
                  :payment payment)])])]))

;; fixme: move to manubbies cmp
(mf/defc attendance-section [{:keys [provider claims]}]
  (let [{:keys [claim-id resource-id nearest-classes classes one-time-assigments]} (:main claims)
        last-one-time (tick/>> (tick/today)
                               (tick/new-period 5 :weeks))
        nearest-one-time-assigments
        (mf/with-memo
          [one-time-assigments]
          (->> one-time-assigments
               (filter #(tick/<= (tick/today) (:date %) last-one-time))))
        nearest (->> (concat nearest-classes
                             nearest-one-time-assigments)
                     (sort-by :date))
        nofity-slot (mf/use-state)
        nofity-message (mf/use-state "")

        on-error (fn [x] (js/console.log "err" x))
        on-success (fn [x]
                     (reset! nofity-slot nil)
                     (reset! nofity-message "")
                     (.refetchQueries s/query-client))

        {:keys [isLoading mutate]} (s/use-tx :claim/tx
                                             {:on-error on-error
                                              :on-success on-success})
        submit! (fn []
                  (mutate
                   {:handler-id :claim/absent-notify
                    :claim-id claim-id
                    :resource-id resource-id
                    :provider-id (:provider/id provider)
                    :date (:date @nofity-slot)
                    :slot-id (:id (:slot @nofity-slot))
                    :message @nofity-message}))]

    [:> ch/Box {}

     [:> ch/Modal
      {:is-open @nofity-slot
       :on-close #(reset! nofity-slot nil)}
      [:> ch/ModalOverlay {}]
      [:> ch/ModalContent {}
       [:> ch/ModalHeader {}
        "Zgłoś nieobecność"]
       [:> ch/ModalCloseButton {}]
       (when @nofity-slot
         [:*
          [:> ch/ModalBody {}
           [:> ch/Text {}
            "Moje dziecko będzie nieobecne na zajęciach: "]
           [:> ch/Text
            {:mb 2
             :text-align :center
             :font-size :xl
             :font-weight :semibold}
            (tick/format "dd.MM.yyyy" (:date @nofity-slot))]
           [:> ch/Text {:mb 2}
            "Nieobecności zgłoszone na 12h przed zajęciami można odrabiać."]
           [:> ch/Text {:mb 2}
            "Umawianie odrabiania prosimy zgłaszać mailowo na "
            [:> ch/Link {:color :brand.500 :font-weight :bold :href "mailto:hello@manubbies.pl"} "hello@manubbies.pl"]]
           ;Podaj poniżej termin, w którym dziecko mogłoby odrobić nieobecność. Jeśli nie znasz terminu, skontaktujemy się z Tobą później.
           #_[:> ch/Textarea
              {:placeholder "Wiadomość"
               :rows 4
               :value @nofity-message
               :on-change #(reset! nofity-message (-> % .-target .-value))}]]
          [:> ch/ModalFooter {}
           [:> ch/Button {:on-click #(reset! nofity-slot nil) :mr 3}
            "Anuluj"]
           [:> ch/Button {:on-click submit!
                          :color-scheme :brand}
            "Zgłoś"]]])]]

     [:> ch/Heading
      {:size :md
       :mb 6
       :text-align :center}
      "Najbliższe zajęcia"]
     (for [x nearest
           :when (:slot x)
           :let [attendance (get-in classes
                                    [{:date (:date x)
                                      :slot-id (:id (:slot x))} :attendance])]]
       [:> ch/Flex
        {:align :center
         :justify :space-around
         :mb 4
         :font-size :lg
         :text-align :center}
        [:> ch/Text
         {:font-weight :semibold
          :font-size :xl}
         [:> ch/Icon
          {:as icons/FaCalendarDay
           :color :brand.500
           :font-size :md
           :mr 2}]
         (tick/format "dd.MM" (:date x))]
        [:> ch/Text {}
         [:> ch/Icon
          {:as icons/FaClock
           :color :brand.500
           :font-size :md
           :mr 2}]
         (str (get-in x [:slot :time]))]
        [:> ch/Text {}
         [:> ch/Icon
          {:as icons/FaHourglassHalf
           :color :brand.500
           :font-size :md
           :mr 2}]
         (tick/minutes (get-in x [:slot :length])) "\u00A0min"]

        [:> ch/Box {:min-w "150px" :text-align :center}
         (cond
           (= (:reason x) :replacement)
           [:> ch/Tag
            {:variant :solid
             :color-scheme :blue}
            "odrabianie"]

           (= (:reason x) :additional)
           [:> ch/Tag
            {:variant :solid
             :color-scheme :green}
            "dodatkowe"]

           (= :absent-notified attendance)
           [:> ch/Tag
            {:variant :solid
             :color-scheme :orange}
            "zgłoszona nieobecność"]

           (and
            (not (:reason x))
            (tick/< (tick/now)
                    (tick/<< (tick/at (:date x) (get-in x [:slot :time]))
                             (tick/new-duration 12 :hours))))
           [:> ch/Button
            {:size :sm
             :on-click #(reset! nofity-slot x)}
            "zgłoś nieobecność"]
           :else "")]])]))

(mf/defc order-status
  {::mf/register app/components
   ::mf/register-as :offer/order-status}
  [{:keys [provider offer payments thx-text thx-header order claims] :as params}]
  (let [t (hooks/use-t "offer")
        payments (sort-by :payment/due-date payments)
        status (:order/status order)
        order-state (:order/state order)
        short-id (-> (:order/id order) (.substr 0 4) (.toUpperCase))
        route-state @(s/use-atom app/route-state)
        thx-page? (= (:thx route-state) "1")]
    (use-track "Order status view"
               {;"Order state" (:order/state order)
                :offer-id (:offer/id offer)
                :provider-id (:provider-id provider)
                "Offer name" (t (:offer/name offer))
                "Payments count" (count payments)})
    [:> ch/Box {}
     [:& app/parallax-image-card
      {:top-space 72
       :image (get-in provider [:provider/business-info :background-image])}

      [:> ch/Box {:px 4 :py 8}
       [:> ch/Heading
        {:size :md :mb 4}
        (t (:offer/name offer))]

       [:> ch/HStack
        {:w :full
         :justify :space-between
         :mb 6}
        [:> ch/Text {} (t {:pl "Zamówienie"
                           :en "Order"})
         " #" short-id]
        [:> ch/Text {:font-size :sm} (date-time-format (:order/created-at order))]]

       (cond
         (= status :cancelled)
         [:> ch/Box {}
          [:> ch/Flex
           {:color :red.500
            :font-size :lg
            :justify :center
            :align :center
            :font-weight :semibold}
           [:> ch/Icon {:as icons/FaTimesCircle
                        :mr 4
                        :font-size :2xl}]
           (t {:pl "Anulowane"
               :en "Cancelled"})]
          [:> ch/Text
           {:align :center
            :mt 4}
           [:b (t {:pl "Powód:"
                   :en "Reason:"})] [:br]
           (t (:order/cancellation-reason order-state))]]

         (or (empty? payments) thx-page?)
         [:> ch/Box
          {:text-align :center
           :p 8}
          [:> ch/Icon
           {:as FaCheckCircle
            :font-size 48
            :color :green.500}]
          [:> ch/Heading
           {:size :md :p 8 :white-space :pre-wrap}
           (or (t thx-header) "Dziękujemy za złożone zamówienie!")]
          [:> ch/Text
           {:pb 8
            :white-space :pre-wrap}
           (t thx-text)]]

         ; fixme refactor to cmp for manubbies
         (seq? payments)
         (let [attendence? (get-in params [:claims :main :nearest-classes])]
           (if (and (= (:provider/id provider) "manubbies")
                    (or attendence?
                        (:edit-form params)
                        #_(#{}
                           (:offer/id offer))))
             [:> ch/Tabs
              {:color-scheme :green ;:brand
               :is-fitted true
               :variant :enclosed-colored
               :mx -4}
              [:> ch/TabList {}
               [:> ch/Tab {} "Płatności"]
               (if attendence?
                 [:> ch/Tab {} "Obecności"]
                 [:> ch/Tab {} "Obiady"])]
              [:> ch/TabPanels {}
               [:> ch/TabPanel {}
                [:& payments-section params]]
               [:> ch/TabPanel {}
                (if attendence?
                  [:& attendance-section params]
                  (app/render-cmp {:app/component :manubbies/lunches
                                   :edit-form (:edit-form params)
                                   :provider-id (:provider/id provider)
                                   :offer-id (:offer/id offer)
                                   :order-id (:order/id order)
                                   :schema (:schema params)
                                   :claims (:claims params)})
                  #_[:> ch/Text
                     {:mt 8
                      :text-align :center}
                     "Możliwość zamawiania obiadów pojawi się wkrótce"])]]]
             [:& payments-section params])))]]]))

(mf/defc go-back-warning []
  (let [; toast (ch/useToast) ; toast doesn't work here (bug in chakra?)
        opened (mf/use-state false)]

    (mf/with-effect
      (js/window.history.pushState #js {:_t 1} ""
                                   (str js/window.location.pathname "#1"))
      (letfn [(listener
                [e]
                (reset! opened true)
                (js/window.removeEventListener "popstate" listener)
                (track "Payment abort warning shown" {}))]
        (js/window.addEventListener "popstate" listener)
        (fn []
          (js/window.removeEventListener "popstate" listener))))
    [:> ch/AlertDialog
     {:is-open @opened
      :on-close #(reset! opened false)}
     [:> ch/AlertDialogOverlay {}
      [:> ch/AlertDialogContent {}
       [:> ch/AlertDialogHeader {}
        "Nie przerywaj procesu płatności"]
       [:> ch/AlertDialogFooter {}
        [:> ch/Button
         {:on-click #(reset! opened false)}
         "OK"]]]]]))

(mf/defc default-payment-screen
  {::mf/register app/components
   ::mf/register-as :screen/payment}
  [{:keys [provider offer order-state payment thx-text] :as params}]
  (let [tracking-params (get-tracking-params
                         {:type :initiate-checkout
                          :provider-id (:provider/id provider)
                          :offer offer
                          :customer (:customer order-state)
                          :payment payment})]
    (use-track "Payment screen view"
               {:offer-id (:offer/id offer)
                :provider-id (:provider/id provider)
                "Paymant status" (:payment/status payment)
                "Payment amount" (:payment/amount payment)})
    (use-track
     (mf/deps (hash payment))
     :initiate-checkout
     tracking-params
     (boolean (some #{:initiate-checkout} (:offer/tracking offer))))

    [:> ch/Box {}

     (when (#{:requested :waiting} (:payment/status payment))
       [:& go-back-warning {}])

     [:& app/parallax-image-card
      {:top-space 72
       :image (get-in provider [:provider/business-info :background-image])}

      [:> ch/Box {:py 4}
       #_[:> ch/Heading
          {:size :lg :mb 4 :text-align :center}
          (t (:offer/name offer))]

       [:& payment/payment-box
        (assoc params
               :customer (:customer order-state)
               :default-opened? true
               :standalone? true)]]]]))

(mf/defc disabled-offer
  {::mf/register app/components
   ::mf/register-as :offer/disabled}
  [{:keys [provider]}]
  (let [home-offer-id (:home-offer-id (:provider/business-info provider))
        home-href (when home-offer-id
                    (routing/href :screen/offer {:provider-id (:provider/id provider)
                                                 :offer-id home-offer-id}))]
    (mf/with-effect
      [home-offer-id]
      (when home-offer-id
        (rfe/replace-state
         :screen/offer {:provider-id (:provider/id provider)
                        :offer-id home-offer-id})))
    [:> ch/Box {}
     [:> ch/Box
      {:text-align :center
       :py 10}
      [:> ch/Heading
       {:size :md
        :px 10}
       "Wybrana przez Ciebie oferta nie jest już dostępna"]
      [:> ch/Text {:my 10}
       "Przejdź do strony głównej żeby zobaczyć dostępne oferty!"]
      (when home-href
        [:> ch/Button
         {:color-scheme :brand
          :as "a"
          :href home-href}
         "ZOBACZ OFERTY"])]]))

(mf/defc go-back-modal
  {::mf/register app/components
   ::mf/register-as :go-back-modal}
  [{:keys [title text back-offer provider-id]}]
  (let [opened? (mf/use-state true)
        route-state @(s/use-atom app/route-state)
        t (hooks/use-t "offer")]
    [:> ch/Modal
     {:is-open @opened?
      :on-close #(reset! opened? false)}
     [:> ch/ModalOverlay {}]
     [:> ch/ModalContent {}
      [:> ch/ModalHeader {} (t title)]
      [:> ch/ModalCloseButton {}]
      [:> ch/ModalBody {}
       [:> ch/Text
        {:white-space :pre-wrap}
        (t text)]]
      [:> ch/ModalFooter {:justify-content :center}
       [:> ch/Button
        {:mr 4
         :as "a"
         :href (offer-path provider-id
                           (drop-path (:path route-state))
                           back-offer
                           nil)
         :on-click #(.preventDefault %)}
        "WRÓĆ"]
       [:> ch/Button {:color-scheme :brand :on-click #(reset! opened? false)} "DALEJ"]]]]))
